export function usePageAccess() {
  // const getAllFormAccessByPublicId = async (publicId: string) => {
  //   const res = await $fetch(`/api/v1/page-access`, {
  //     method: 'GET',
  //     params: {
  //       publicId: publicId,
  //     },
  //   })
  //   return res
  // }

  const getPageAccessByContactId = async (contactId: string) => {
    const res = await $fetch(`/api/v1/page-access/by-contact/${contactId}`, {
      method: 'GET',
    })
    return res
  }

  const getAllPageAccessByBusinessId = async (businessId: string) => {
    const res = await $fetch(`/api/v1/business/${businessId}/get-all-form-access`, {
      method: 'GET',
    })
    return res
  }
  const getPageAccessById = async (accessId: string) => {
    const res = await $fetch(`/api/v1/page-access/${accessId}`, {
      method: 'GET',
    })
    return res
  }

  const getPublicPageAccessById = async (accessId: string, email: string) => {
    const res = await $fetch(`/api/public/page-access/${accessId}`, {
      method: 'POST',
      body: { email },
    })
    return res
  }

  const getAllPageAccessStatus = async () => {
    const res = await $fetch(`/api/v1/page-access/get-status`, {
      method: 'GET',
    })
    return res
  }

  const createPageAccess = async (body) => {
    try {
      const res = await $fetch(`/api/v1/page-access/create`, {
        method: 'POST',
        body: body,
      })
      return res;
    } catch (error) {
      console.error('Error creating page access record:', error);
      return { data: null, error };
    }
  }

  const sendCARequest = async (body) => {
    const res = await $fetch(`/api/v1/page-access/send-ca`, {
      method: 'POST',
      body: body,
    })
    return res
  }

  const updatePageAccess = async (body) => {
    const res = await $fetch(`/api/v1/page-access/${body.id}`, {
      method: 'PUT',
      body: body,
    })
    return res
  }

  const updateBuyerInterestInPageAccess = async (body) => {
    const res = await $fetch(`/api/v1/page-access/${body.id}/update-buyer-interest`, {
      method: 'PUT',
      body: body,
    })
    return res
  }

  return {
    getAllPageAccessStatus,
    createPageAccess,
    updatePageAccess,
    getPageAccessByContactId,
    getAllPageAccessByBusinessId,
    sendCARequest,
    getPageAccessById,
    getPublicPageAccessById,
    updateBuyerInterestInPageAccess,
  }
}
